<template>
  <q-search
    v-model="countryName"
    :name="name"
    :placeholder="placeholderText"
  >
    <q-autocomplete
      :static-data="{ field: 'label', list: countries }"
      :debounce="defaultSearchDebounce"
      :min-characters="0"
      :max-height="'200px'"
      :max-results="500"
      :value-field="v => v.label"
      @selected="selected"
    />
  </q-search>
</template>

<script>
  import countries from './countries'
  import debounceMixin from 'src/utils/mixins/debounce'
  import { mapGetters } from 'vuex'

  export default {
    inject: ['$validator'],

    props: {
      /**
       * Used for v-model
       */
      value: {
        type: String,
        required: true
      },

      /**
       * Placeholder text
       */
      placeholder: {
        type: String,
        required: false,
        default: null
      },

      /**
       * Input name
       */
      name: {
        type: String,
        required: false,
        default: 'countryCode'
      }
    },

    data () {
      return {
        countryName: ''
      }
    },

    computed: {
      ...mapGetters(['locale']),

      placeholderText () {
        return this.placeholder ? this.placeholder : this.$t('country')
      },

      countries () {
        return countries[this.locale]
      }
    },

    created () {
      if (this.value) {
        this.updateName()
      }
    },

    watch: {
      value: function (val) {
        this.updateName()
      }
    },

    methods: {
      selected (item) {
        this.$emit('input', item.value)
      },

      updateName () {
        const country = this.countries.find(country => country.value === this.value)

        this.countryName = country ? country.label : null
      }
    },

    mixins: [
      debounceMixin
    ]
  }
</script>
